import { useState, useMemo, useEffect } from "react";
import styles from "./resources/css/proxyLoading.module.css";
import SimpleLoader from "./components/loaders/SimpleLoader";
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import Turnstile, { useTurnstile } from "react-turnstile";


import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AddressComponent from "./AddressComponent";
import CollectionsComponent from "./CollectionsComponent";
import Four04 from "./Four04";
import Home from "./Home";
import ScrollToTop from "./ScrollToTop";
import SingleCollectionComponent from "./SingleCollectionComponent";
import DomainSearchComponent from "./DomainSearchComponent";
import TxnComponent from "./TxnComponent";

import '@solana/wallet-adapter-react-ui/styles.css';
// import FeedComponent from "./FeedComponent";
import SearchComponent from "./components/SearchComponent";
import axios from "axios";


const Parent = () => {
    const [popup, setPopUp] = useState(false);
    const network = WalletAdapterNetwork.Devnet;
    const [currentWallet, setConnectedWallet] = useState("");
    const [activeWallet,setActiveWallet] = useState("");
    
    const pubKeyFromSession = "";

    const [reconnectTest,setReconnectTest] = useState(false);
    const [reverseCheck,setReverseCheck] = useState(false);
    const turnstile = useTurnstile();

    const [turnstileValueSet, setTurnstileValueSet] = useState(false);

    return (
        <div>
            
            {turnstileValueSet &&
                <Router>
                    <ScrollToTop />
                    <Routes>
                        <Route exact path="/" element={
                            
                                    <Home popup={popup} setPopUp={setPopUp} />
                                
                        } />
                        <Route exact path="/address/:addr" element={
                            <>
                                        <div className="container pt-2 pb-1">
                                            <SearchComponent popup={popup} setPopUp={setPopUp} currentWallet={currentWallet} setActiveWallet={setActiveWallet} reconnectTest={reconnectTest} setReconnectTest={setReconnectTest} reverseCheck={reverseCheck}/>
                                        </div>
                                <AddressComponent popup={popup} setPopUp={setPopUp} currentWallet={currentWallet} activeWallet={activeWallet} reconnectTest={reconnectTest} reverseCheck={reverseCheck} setReverseCheck={setReverseCheck}/>
                            </>
                        } />
                        <Route exact path="/domain/:addressOrDomain" element={<DomainSearchComponent popup={popup} setPopUp={setPopUp}  />} />
                        <Route exact path="/tx/:txn" element={
                            <TxnComponent popup={popup} setPopUp={setPopUp} />
                        } />
                        <Route exact path="/collections/:addr" element={<CollectionsComponent popup={popup} setPopUp={setPopUp} />} />
                        <Route exact path="/collection/:addr" element={<SingleCollectionComponent popup={popup} setPopUp={setPopUp} />} />

                        {/* <Route exact path="/:type/:addr" element={<TokenComponent />} /> */}
                        <Route exact path="*" element={<Four04 />} />
                    </Routes>
                </Router>
            }
            {!turnstileValueSet &&
                <div className={styles.background_super_proxy}>
                    <div className="container-lg pt-4 pt-md-5 pt-xl-3">
                        <SimpleLoader />
                    </div>
                </div>
            }
            <div className="d-flex justify-content-center w-100 py-2">
                <Turnstile
                    sitekey={`${process.env.REACT_APP_CFLARE_SITE_KEY}`}
                    onExpire={() => turnstile.reset()}
                    onVerify={async (token) => {
                        await axios.request({
                            method: "POST",
                            url: `${process.env.REACT_APP_PROXY_URL}/verify_token`,
                            data: { token: token },
                        }).then((response) => {
                            if(response.data.success)
                                localStorage.setItem("tcfAuthTkn", response.data.authToken);
                            // else
                            //     turnstile.reset();
                            if(!turnstileValueSet)
                                setTurnstileValueSet(true);
                        }).catch((error) => {
                            console.log(error);
                            // turnstile.reset();
                        })
                        
                    }}
                />
            </div>
        </div>
    );
}

export default Parent;